import { wrap } from '@repo/di-ez';

import { SortableSettingItem } from '../SortableSettingItem';

type Props = {
  field: string;
  isPinned: boolean;
  isVisible: boolean;
  isVisibilitySwitcherDisabled: boolean;
  isDragDisabled?: boolean;
  title?: string;
  onColumnVisibilityChange(column: string, value: boolean): void;
  unpinColumn(field: string): void;
};

/** Table-column settings row — thin wrapper over SortableSettingItem with pin support. */
export const DisplaySettingItem = wrap<Props>(function DisplaySettingItem({
  field,
  title,
  isVisible,
  isPinned,
  isDragDisabled = false,
  onColumnVisibilityChange,
  unpinColumn,
  isVisibilitySwitcherDisabled,
}) {
  return (
    <SortableSettingItem
      id={field}
      title={title}
      isVisible={isVisible}
      isPinned={isPinned}
      isDragDisabled={isDragDisabled}
      isVisibilitySwitcherDisabled={isVisibilitySwitcherDisabled}
      onVisibilityChange={onColumnVisibilityChange}
      onUnpin={unpinColumn}
    />
  );
});
